<nb-card>
  <nb-card-header class="default-card-header">
    {{ 'Replacement asset' | translate }}
  </nb-card-header>
  <nb-card-body>
    @if (asset) {
      <div (click)="navigateToAsset(asset.id)" class="asset-row">
        <!-- ASSET PICTURE -->
        @if (asset.pictures?.length) {
          <div class="img-box">
            <img [src]="getThumbnailUrl()" class="img-thumbnail">
          </div>
        }
        @if (!asset.pictures?.length) {
          <div class="no-img-box">
            <span>{{ "No picture" | translate }}</span>
          </div>
        }
        <div class="item-label ms-3">
          <!-- ASSET LABEL-->
          <span class="asset-label">{{ asset.label }}</span>
          <!-- INSTALLATION YEAR -->
          @if (asset.asset_type_object) {
            <span class="asset-type">{{ 'pages.insight.assets.column_asset_type' | translate }}: {{ asset.asset_type_object.name }}</span>
          }
        </div>
      </div>
    }
    <!-- No replacement equipment planned -->
    @if (!asset) {
      <div class="asset-row">
        <div class="item-label row">
          <!-- ASSET LABEL-->
          <span class="asset-type">{{ "No replacement equipment planned" | translate }}</span>
        </div>
      </div>
    }
  </nb-card-body>
</nb-card>
